import { render, staticRenderFns } from "./CuratedRtqInstumentsTable.vue?vue&type=template&id=0d80b7ce&scoped=true"
import script from "./CuratedRtqInstumentsTable.vue?vue&type=script&lang=ts"
export * from "./CuratedRtqInstumentsTable.vue?vue&type=script&lang=ts"
import style0 from "./CuratedRtqInstumentsTable.vue?vue&type=style&index=0&id=0d80b7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d80b7ce",
  null
  
)

export default component.exports